import { useStaffMe } from "../context/StaffMeContext";

/**
 * Hook providing granular RBAC checks matching RBACStack pattern.
 */
export function usePermission() {
  const me = useStaffMe();

  const isSuperUser = me.role === "developer" || me.role === "admin";

  const hasPermission = (permission: string): boolean => {
    if (isSuperUser) return true;
    if (!me.permissions) return false;
    return me.permissions.includes(permission) || me.permissions.includes("*");
  };

  const hasAnyPermission = (permissions: string[]): boolean => {
    if (isSuperUser) return true;
    return permissions.some(hasPermission);
  };

  const hasAllPermissions = (permissions: string[]): boolean => {
    if (isSuperUser) return true;
    return permissions.every(hasPermission);
  };

  const hasRole = (role: string): boolean => {
    return me.role === role;
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
    role: me.role,
    permissions: me.permissions ?? [],
    isSuperUser,
  };
}
